export default {
  carBrandsData(state) {
    return state.carBrands
    },
  carCategoriesData(state) {
    return state.carCategories
  },
};
